import {ReactElement} from 'react';

export const KEEP_TOAST_OPEN = 'KEEP_TOAST_OPEN';

export const DEFAULT_DURATION = 7;
export const LONG_DURATION = 10;

export interface ToastAction {
  actionText?: string;
  onActionClick?: (() => void | typeof KEEP_TOAST_OPEN) | (() => Promise<void>);
  clipboardData?: string;
}

export enum ToastType {
  SUCCESS = 'success',
  WARNING = 'warning',
  INFO = 'info',
  DANGER = 'danger',
}

export type ToastId = string | number;

export interface Toast {
  id?: ToastId;
  actions?: Array<ToastAction>;
  actionText?: string;
  clipboardData?: string;
  duration?: number;
  isCloseable?: boolean;
  // When pushing a toast with an ID, message may be omitted, in which case the same message as
  // before is used.
  message?: string | ReactElement;
  onActionClick?: (() => void | typeof KEEP_TOAST_OPEN) | (() => Promise<void>);
  onClose?: () => void;
  progress?: number;
  skipCloseCallbackOnActions?: boolean;
  type?: ToastType;
  stack?: boolean;
  timeoutId?: NodeJS.Timeout | null;
}

export interface RenderedToast extends Toast {
  id: ToastId;
  type: ToastType;
}
